<template>
  <div class="block-flat">
    <div class="header">
      <h3>Pièces jointes à la demande</h3>
    </div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
      <b-form v-if="request" @submit.prevent="handleSubmit(send())">
        <div class="block-content">
          <div class="form-group">
            <b-form-group>
              <legend>1. Pièces pour toute demande</legend>
              <div
                v-for="document in missingDocuments"
                :key="document.typeDocument.id"
              >
                <div v-if="request.type != 1">
                  <b-row v-if="document.typeDocument.isMandatory == true">
                    <!-- Documents pour permission et accès -->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="request.type != 2"
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="request.type != 2"
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        drop-placeholder="Glissez un Fichier ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        required
                      ></b-form-file>
                    </b-col>
                    <!-- Documents pour dde alignement avec photo pas obligatoire-->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="
                        request.type == 2 &&
                          document.typeDocument.id != 85 &&
                          document.typeDocument.id != 79 &&
                          document.typeDocument.id != 80
                      "
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="
                        request.type == 2 &&
                          document.typeDocument.id != 85 &&
                          document.typeDocument.id != 79 &&
                          document.typeDocument.id != 80
                      "
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        drop-placeholder="Glissez un Fichier ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        required
                      ></b-form-file>
                    </b-col>
                    <!-- Documents pour dde alignement avec photo pas obligatoire 2 -->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="request.type == 2 && document.typeDocument.id == 85"
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}
                        <span class="red"></span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="request.type == 2 && document.typeDocument.id == 85"
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        drop-placeholder="Glissez un Fichier ici..."
                      ></b-form-file>
                    </b-col>
                  </b-row>
                </div>
                <div v-else>
                  <b-row v-if="document.typeDocument.isMandatoryReseaux == true">
                    <!-- Documents pour permission et accès -->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="request.type != 2"
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="request.type != 2"
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        drop-placeholder="Glissez un Fichier ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        required
                      ></b-form-file>
                    </b-col>
                    <!-- Documents pour dde alignement avec photo pas obligatoire-->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="
                        request.type == 2 &&
                          document.typeDocument.id != 85 &&
                          document.typeDocument.id != 79 &&
                          document.typeDocument.id != 80
                      "
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}<span class="red">*</span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="
                        request.type == 2 &&
                          document.typeDocument.id != 85 &&
                          document.typeDocument.id != 79 &&
                          document.typeDocument.id != 80
                      "
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        drop-placeholder="Glissez un Fichier ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        required
                      ></b-form-file>
                    </b-col>
                    <!-- Documents pour dde alignement avec photo pas obligatoire 2 -->
                    <b-col
                      xl="3"
                      lg="4"
                      md="4"
                      sm="12"
                      cols="12"
                      v-if="request.type == 2 && document.typeDocument.id == 85"
                    >
                      <label class="control-label">
                        <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                          <font-awesome-icon icon="question-circle"></font-awesome-icon>
                        </span>
                        {{ document.typeDocument.name }}
                        <span class="red"></span> :
                      </label>
                    </b-col>
                    <b-col
                      xl="9"
                      lg="8"
                      md="8"
                      sm="12"
                      cols="12"
                      v-if="request.type == 2 && document.typeDocument.id == 85"
                    >
                      <b-form-file
                        browse-text="Déposer"
                        v-model="document.file"
                        placeholder="Choisissez un Fichier ou glissez le ici..."
                        accept="image/jpeg, application/pdf, image/png"
                        drop-placeholder="Glissez un Fichier ici..."
                      ></b-form-file>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-form-group>
            <b-form-group>
              <legend>2. Pièces Complémentaires</legend>
              <!-- cloture stationnement -->
              <div
                v-for="document in missingDocuments"
                :key="document.typeDocument.id"
              >
                <b-row
                  v-if="
                    document.typeDocument.isMandatory == false &&
                      document.typeDocument.name != 'Arrêté de décision' &&
                      document.typeDocument.name !=
                        'Arrêté de décision SIGNÉ' &&
                      document.typeDocument.name != 'Annexe décision' &&
                      document.typeDocument.name != 'Plan de masse existant' &&
                      document.typeDocument.name != 'Plan de masse projet' &&
                      document.typeDocument.name != 'Plan projet' &&
                      document.typeDocument.name !=
                        'Plan de situation 1/10 000 ou 1/20 000' &&
                      document.typeDocument.name !=
                        'Plan de localisation précis 1/1000 ou 1/2000 ' &&
                      document.typeDocument.name != 'Plan cadastral'
                  "
                >
                  <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                    <label class="control-label">
                      <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                        <font-awesome-icon icon="question-circle"></font-awesome-icon>
                      </span>
                      {{ document.typeDocument.name }}
                    </label>
                  </b-col>
                  <b-col xl="9" lg="8" md="8" sm="12" cols="12">
                    <b-form-file
                      browse-text="Déposer"
                      v-model="document.file"
                      placeholder="Choisissez un Fichier ou glissez le ici..."
                      accept="image/jpeg, application/pdf, image/png"
                      drop-placeholder="Glissez un Fichier ici..."
                    ></b-form-file>
                  </b-col>
                </b-row>
                <div v-if="soustypes != null">
                  <div v-for="soustype in soustypes.split(',')" :key="soustype">
                    <b-row
                      v-if="
                        document.typeDocument.isMandatory == false &&
                          (document.typeDocument.cerfa == 1 ||
                            document.typeDocument.cerfa == 2) &&
                          document.typeDocument.nature != null &&
                          document.typeDocument.nature
                            .split(',')
                            .includes(soustype)
                      "
                    >
                      <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                        <label class="control-label">
                          <span v-b-tooltip.hover title="Fichiers acceptés: .pdf, .jpg / .jpeg, .png">
                            <font-awesome-icon icon="question-circle"></font-awesome-icon>
                          </span>
                          {{ document.typeDocument.name }}
                        </label>
                      </b-col>
                      <b-col xl="9" lg="8" md="8" sm="12" cols="12">
                        <b-form-file
                          browse-text="Déposer"
                          v-model="document.file"
                          placeholder="Choisissez un Fichier ou glissez le ici..."
                          accept="image/jpeg, application/pdf, image/png"
                          drop-placeholder="Glissez un Fichier ici..."
                        ></b-form-file>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="stepper-control">
          <b-button
            variant="white"
            @click="previous"
            class="btn marginRight-10 marginBottom-15"
          >
            <font-awesome-icon
              icon="caret-left"
              class="marginRight-5"
            ></font-awesome-icon>
            Précédent
          </b-button>
          <b-button type="submit" variant="warning" class="marginBottom-15">
            <span>Suivant</span>
            <font-awesome-icon
              icon="caret-right"
              class="marginLeft-5"
            ></font-awesome-icon>
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

export default {
  props: ["value"],
  name: "PiecesJointes",
  async mounted() {
    // console.log('test', this.request.missingDocuments)
    await this.getMissingDocuments(this.request);
  },
  data: () => ({
    piece: {
      file: null,
      name: null,
      path: null,
      url: null,
      typeDocument: {
        name: null,
        cerfa: [],
        nature: [],
      },
    },
  }),
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023", "alignement"]),
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Document", ["missingDocuments"]),
    soustypes: function() {
      if (this.cerfa14023) {
        return this.cerfa14023.themes;
      } else {
        return null;
      }
    },
    request: {
      get() {
        return this.dossierSelected;
      },
      set(value) {
        this.$emit("setDossier", value);
      },
    },
    pieces: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    previous() {
      this.$emit("previous");
    },
    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
    ...Vuex.mapActions("Document", ["getMissingDocuments"]),
  },
};
</script>
